var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"visual"},[_c('div',{staticClass:"head"},[_c('h3',[_vm._v("视觉交控")]),_vm._v(" "),_c('span',{on:{"click":_vm.toMore}},[_vm._v("查看更多")])]),_vm._v(" "),_c('div',{staticClass:"list"},_vm._l((_vm.picList),function(pic){return _c('div',{key:pic.id,style:({ background: ("center / cover no-repeat url(" + (pic.picturePath) + ")") })})}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24d25b0d","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/home/Visual.vue
// module id = null
// module chunks = 